import axios from 'axios';
import { Schedule } from '../models/schedule';
import { formatDate } from '../utils/formatter';

export const getAllSchedules = async (date: string): Promise<Schedule[]> => {
    const requestDate = formatDate({ date: date, destFormat: 'YYYY-MM-DD', srcFormat: 'YYYYMMDD' });
    const response = await axios.get(`/api/schedule/date/${requestDate}`);
    return response.data;
};

export const getSchedules = async (providerId: number, date: string): Promise<Schedule[]> => {
    const requestDate = formatDate({ date: date, destFormat: 'YYYY-MM-DD', srcFormat: 'YYYYMMDD' });
    const response = await axios.get(`/api/schedule/provider/${providerId}/date/${requestDate}`);
    return response.data;
};
